module.exports = __webpack_public_path__ + "static/media/BNB_BSW_Biswap.be69455b.png";